import type { FallbackPanelViewData } from '@shared/types/views';
import { Link } from 'react-router-dom';

interface FallbackPanelViewProps {
  hideTitle?: boolean;
  data: FallbackPanelViewData;
}

const FALLBACK_MESSAGES: Record<string, string> = {
  ad_hoc_view_payload_invalid: 'Le résultat n’a pas pu être affiché correctement.',
  dashboard_view_payload_missing: 'Le résultat n’est pas encore disponible.',
  pattern_missing: 'Le résultat n’a pas pu être affiché correctement.',
  pattern_unregistered: 'Le résultat n’a pas pu être affiché correctement.',
  preview_invalid: 'L’aperçu n’est pas encore disponible.',
  source_dispatch_unsupported: 'Cette action doit être lancée depuis une surface dédiée.',
  source_error: 'Le résultat n’a pas pu être affiché.',
  source_no_data: 'Aucune donnée exploitable pour le moment.',
  source_plan_missing: 'Le résultat n’est pas encore disponible.',
  view_payload_invalid: 'Le résultat n’a pas pu être affiché correctement.',
  view_payload_mismatch: 'Le résultat n’a pas pu être affiché correctement.',
  view_payload_missing: 'Le résultat n’est pas encore disponible.',
};

const TECHNICAL_TITLE_PATTERN = /\b(fallback|payload|pattern|sourceplan|view)\b/i;

const getDisplayTitle = (data: FallbackPanelViewData): string => {
  if (!data.title || TECHNICAL_TITLE_PATTERN.test(data.title)) {
    return 'Résultat indisponible';
  }
  return data.title;
};

const getDisplayMessage = (data: FallbackPanelViewData): string => {
  if (data.message?.trim()) return data.message;
  const reasonMessage = data.reason ? FALLBACK_MESSAGES[data.reason] : undefined;
  if (reasonMessage) {
    return reasonMessage;
  }
  return data.message || 'Le résultat n’a pas pu être affiché correctement.';
};

const isCrmOwnerMissing = (data: FallbackPanelViewData): boolean =>
  /propri[eé]taire CRM/i.test(data.message ?? '');

export const FallbackPanelView = ({ data, hideTitle }: FallbackPanelViewProps) => {
  return (
    <div data-view-surface className="rounded-xl border border-domino-cardBorder bg-domino-lilac p-4">
      {!hideTitle && <p className="text-sm font-semibold text-domino-aubergine">{getDisplayTitle(data)}</p>}
      <p className="mt-1 text-sm text-domino-ink">{getDisplayMessage(data)}</p>
      {isCrmOwnerMissing(data) && (
        <Link to="/connections" className="mt-3 inline-flex text-sm font-semibold text-domino-aubergine underline underline-offset-4">
          Vérifier le compte HubSpot
        </Link>
      )}
    </div>
  );
};
